import { useRegion } from 'common/hooks/region';
import { DateTime } from 'luxon';
import * as React from 'react';
import { TerminalRemote } from 'services/clients/terminal';
import { NextAppointmentsService } from '../../NextAppointments/services/next-appointments.service';
import { CheckSystemCell } from './CheckSystemCell';

interface Props {
  terminal: TerminalRemote;
  lastRefreshData?: Record<
    string,
    Record<string, { last_recording_time: string; total_appointments: null | number }>
  >;
  selectedSlKey: string;
  classes: Record<string, string>;
}

export const LastRefreshCell: React.FC<Props> = (props) => {
  const region = useRegion();
  const { lastRefreshData, selectedSlKey, terminal, classes } = props;

  const dataByTerminal = (lastRefreshData || {})[terminal.key];
  let lastRefreshTime = '';
  if (dataByTerminal && dataByTerminal[selectedSlKey]) {
    lastRefreshTime = dataByTerminal[selectedSlKey].last_recording_time;
  }

  if (lastRefreshTime) {
    const { timeZone } = region;
    let refreshDate = DateTime.fromFormat(lastRefreshTime, 'yyyy-MM-dd HH:mm:ss ZZ', {
      zone: timeZone,
    });

    if (!refreshDate.isValid) {
      refreshDate = DateTime.fromFormat(lastRefreshTime, 'yyyy-MM-dd HH:mm:ss ZZZ', {
        zone: timeZone,
      });
    }

    if (!refreshDate.isValid) {
      // eslint-disable-next-line no-console
      console.error('Refresh date was invalid format', refreshDate);
      return null;
    }

    // BCIC-806 reduce outdatedHours from 24 to 2
    // if (moment(refreshDate).isSame(today, 'day')) {
    const isLastRefreshOutdated = NextAppointmentsService.checkIsLastRefreshOutdated(
      lastRefreshTime,
      timeZone
    );
    if (isLastRefreshOutdated) {
      return <CheckSystemCell terminal={terminal} classes={classes} />;
    }
    return <>{refreshDate.toFormat('t')}</>;
  }

  return null;
};
